/*global $:false */

import UriBuilder from "../helpers/module.uribuilder.js";
import {format as formatDateTime} from "../fields/recordm.fields.datetime.js";

const RecordmImporterStatM = function(coreArg, statJson) {
    this.core = coreArg;
    this._entityKey = "rm-importer-stat";
    this.stat = {};

    if(statJson){
        this.stat = statJson._source;
        this.stat.id = statJson._id || undefined;
    }
};

RecordmImporterStatM.prototype.isDone = function() {
    return this.stat.end_date !== undefined;
};

RecordmImporterStatM.prototype.get = function(statId) {
    const _this = this;
    const query = "_id:\"" + statId + "\"";
    const url = "recordm/importer-stats/search?q=" + encodeURIComponent(query) + "&size=1";

    $.ajax({
        url: url,
        type: "GET",
        xhrFields:{
            withCredentials: true
        },
        success: function(response) {
            const statJson = response.hits.hits[0];

            if(statJson){
                _this.stat = statJson._source;
                _this.stat.id = statId;

                _this.core.publish("recordm:rm-importer-stats:success", {
                    id:statId,
                    stat: statJson
                });
            }
        },
        error: function(req) {
            _this.core.publish("recordm:rm-importer-stats:error", {
                id:statId,
                status: req.status,
                statusText: req.statusText,
                response:req.responseText
            });
        }
    });
};

RecordmImporterStatM.prototype.getId = function(){
    return this.stat.id;
};

RecordmImporterStatM.prototype.getImportId = function(){
    return this.stat.import_id;
};

RecordmImporterStatM.prototype.getFormattedStartDate = function(locale){
    return (this.stat.start_date !== undefined
            ? formatDateTime(this.stat.start_date, locale)
            : "");
};

RecordmImporterStatM.prototype.getFormattedEndDate = function(locale){
    return (this.stat.end_date !== undefined
            ? formatDateTime(this.stat.end_date, locale)
            : "");
};

RecordmImporterStatM.prototype.getEntityKey = function() {
    return this._entityKey;
};

RecordmImporterStatM.prototype.getSettingKey = function() {
    return this._entityKey;
};

RecordmImporterStatM.prototype.getModelKey = function() {
    return this._entityKey + ":" + this.getId();
};

RecordmImporterStatM.prototype.getSearchableField = function(fieldName) {
    let _column;

    this.getSearchableFields().some(function(field) {
        if (field.fieldName === fieldName) {
            _column = field;
            return true;
        }

        return false;
    });

    return _column;
};

RecordmImporterStatM.prototype.getName = function() {
    //Hack to show "RecordM Importer Stats" on the "summary" stats search
    // and "Filter Line Stats" on the stat details search
    return (this.getId() === undefined
             ? this.core.translateString("recordm-importer.stats", "name")
             : this.core.translateString("recordm-importer.stats", "details-name"));
};

RecordmImporterStatM.prototype.getFullData = function() {
    return this.stat;
};

RecordmImporterStatM.prototype.getUpdateEventName = function() {
    return "recordm:updated:" + this.getModelKey();
};

RecordmImporterStatM.prototype.getDeleteEventName = function() {
    return "recordm:deleted:" + this.getModelKey();
};

RecordmImporterStatM.prototype.release = function() {
    this.core.release(this.getModelKey());
};

RecordmImporterStatM.prototype.buildUriForQuery = function(query) {
    return (this.getId() === undefined
            ? UriBuilder.buildUriForSimpleSearchRmImporterStats(query)
            : UriBuilder.buildUriForImportDetailsWithSimpleSearch(this.getId(), query));
};

RecordmImporterStatM.prototype.buildUriForAdvSearch = function(query) {
    return (this.getId() === undefined
            ? UriBuilder.buildUriForAdvSearchRmImporterStats(query)
            : UriBuilder.buildUriForImportDetailsWithAdvancedSearch(this.getId(), query));
};

RecordmImporterStatM.prototype.setUri = function(uri) {
    this.stat.uri = uri;
};

RecordmImporterStatM.prototype.getUri = function() {
    return this.stat.uri;
};

RecordmImporterStatM.prototype.getInstanceId = function() {
    return this.getId();
};

export default RecordmImporterStatM;
